import { logClientNumber, signalPagePath } from "../signals/login.signal";
import hasJWT from "./hasJWT";

function isTokenValid() {
  const getTokenExpiration = localStorage.getItem("tokenExpiration");
  if (getTokenExpiration) {
    const tokenExpiration = getTokenExpiration;
    console.log("tokenExpiration " + tokenExpiration);
    const currentTime = new Date().getTime();
    return tokenExpiration && currentTime < parseInt(tokenExpiration);
  } else {
    return true;
  }
}

function clearToken() {
  localStorage.removeItem("b2bAppToken");
  localStorage.removeItem("tokenExpiration");
  logClientNumber.value = null;
  signalPagePath.value = false;
}

function setTokenExpiration() {
  hasJWT();
  console.log("isTokenValid " + isTokenValid());
  var checkIsTokenValid = isTokenValid();
  if (checkIsTokenValid == true) {
    const tokenExpiration = new Date().getTime() + 1200000; // 20 minutes in milliseconds
    localStorage.setItem("tokenExpiration", tokenExpiration.toString());
  } else {
    clearToken();
    signalPagePath.value = localStorage.getItem("b2bAppToken") !== null;
  }
}

export { isTokenValid, clearToken, setTokenExpiration };
